import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { paymentTransactionsPrepareData } from '../../../views/developers/ClientLogs';
import { activityActionTypes } from '../activity-action-types';
import { getFormattedDate } from '../../../utils/utilities';
import * as React from 'react';
import { IActivityAction } from '../activity-interfaces';

export const fetchClientsLogsData = async (
	dispatch: React.Dispatch<IActivityAction>,
	currentPage: number,
	chosenDate: any,
	value: string
): Promise<void> => {
	dispatch({ type: activityActionTypes.START_CLIENT_LOGS_DATA_LOADING });
	try {
		const from = chosenDate?.[0] ? getFormattedDate(chosenDate[0], 'yyyy-MM-dd') : '';
		const to = chosenDate?.[1] ? getFormattedDate(chosenDate[1], 'yyyy-MM-dd') : '';
		const res = await axios.get(`${BASE_URL.ACTIVITY}/Activities/logs?pageNumber=${currentPage}&pageSize=10&from=${from}&to=${to}&query=${value}`);
		if (res?.data) {
			const data = paymentTransactionsPrepareData(res?.data);
			dispatch({ type: activityActionTypes.FETCH_CLIENT_LOGS_DATA, payload: data });
		}
	} catch (e) {
		console.log(e);
		dispatch({ type: activityActionTypes.FETCH_FAIL });
	}
};
